let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3jnPT")).then(() => parcelRequire('3Vms4'));